var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinDropoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 3C29 2.44772 29.4477 2 30 2H51.3931C52.1338 2 52.6174 2.77716 52.2902 3.44168L46.3768 15.4534C46.2305 15.7506 46.2408 16.101 46.4044 16.389L52.1514 26.5061C52.5301 27.1727 52.0486 28 51.2819 28H30C29.4477 28 29 27.5523 29 27V3Z",
    fill: "#3BD4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8638 54.5192C25.4779 55.1807 24.5221 55.1807 24.1362 54.5192L18.8773 45.5039C18.4884 44.8372 18.9692 44 19.741 44H30.259C31.0308 44 31.5116 44.8372 31.1227 45.5039L25.8638 54.5192Z",
    fill: "#171B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.999999C24 0.447714 24.4477 0 25 0C25.5523 0 26 0.447715 26 1V44H24V0.999999Z",
    fill: "#171B1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDropoff);
export default __webpack_public_path__ + "static/media/pin-dropoff.29a3ea723fef80e9393ace2cebfbebd1.svg";
export { ForwardRef as ReactComponent };